(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["login"]) return;
  try {
    
  if (window.location.hash === '#recover') {
    document.querySelector('[data-recover-password-button]').click();
  }

  } catch(e) { console.error(e); }
})();
})();
